import { useEffect, useRef } from 'react';
import { cx } from '@linaria/atomic';
import { CheckIconSmall, MinusIconSmall } from '../../../icon';
import type { BoolInputProps } from '../layouts';
import { BoolInput } from './bool-input.component';
import { checkboxBase, stateIcon } from './checkbox.styles';

export const Checkbox = ({
  active,
  error,
  disabled,
  indeterminate = false,
  value,
  tabIndex,
  ...rest
}: BoolInputProps<'checkbox'> & { tabIndex?: number }) => {
  const fieldRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // The only way to set a checkbox to indeterminate in HTML and JavaScript is setting the prop in JavaScript
    if (fieldRef.current) {
      fieldRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const wrapperClassName = cx(
    checkboxBase,
    disabled && 'disabled',
    active && 'active',
    value && 'checked',
    error && 'error'
  );

  const stateIconClassName = cx(stateIcon, value && 'checked');

  return (
    <div className={wrapperClassName}>
      {indeterminate ? (
        <MinusIconSmall color='white' className={stateIconClassName} />
      ) : (
        <CheckIconSmall color='white' className={stateIconClassName} />
      )}

      <BoolInput {...rest} type='checkbox' checked={value} disabled={disabled} ref={fieldRef} tabIndex={tabIndex} />
    </div>
  );
};
